// extracted by mini-css-extract-plugin
export default {"wrapper":"QdqDxPg7sd0oFNF3ivgg","text":"Je_N34wDIQow1FUDv6Hd"};